import { motion } from "framer-motion";
import { useLenis } from "lenis/react";

const links = [
  ["machines", "#machines"],
  ["why", "#why"],
  ["useCases", "#use-cases"],
  ["team", "#team"],
  ["contact", "#contact"],
];

export const Nav = ({ t, lang, setLang }) => {
  const lenis = useLenis();
  const go = (hash) => (e) => {
    e.preventDefault();
    lenis?.scrollTo(hash, { offset: -72 });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-slate-950/60 backdrop-blur-xl"
      data-testid="main-nav"
    >
      <div className="mx-auto flex h-[72px] max-w-[1440px] items-center justify-between px-5 md:px-10">
        <a href="#top" onClick={go("#top")} data-testid="nav-logo" className="block">
          <img src="/assets/logo-white.png" alt="SQB Robotics" className="h-7 w-auto" />
        </a>
        <nav className="hidden items-center gap-8 lg:flex">
          {links.map(([key, hash]) => (
            <a
              key={key}
              href={hash}
              onClick={go(hash)}
              data-testid={`nav-link-${key}`}
              className="font-mono-spec text-[11px] uppercase tracking-[0.2em] text-slate-400 transition-colors duration-300 hover:text-[#00e5ff]"
            >
              {t[key]}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <div className="flex items-center rounded-full border border-white/10 p-0.5" data-testid="lang-toggle">
            {["en", "ro"].map((l) => (
              <button
                key={l}
                onClick={() => setLang(l)}
                data-testid={`lang-${l}-btn`}
                className={`rounded-full px-3 py-1 font-mono-spec text-[11px] uppercase tracking-widest transition-colors duration-300 ${
                  lang === l ? "bg-[#00e5ff] text-slate-950" : "text-slate-400 hover:text-slate-50"
                }`}
              >
                {l}
              </button>
            ))}
          </div>
          <a
            href="#contact"
            onClick={go("#contact")}
            data-testid="nav-cta"
            className="hidden rounded-full border border-[#00e5ff]/50 px-5 py-2 font-mono-spec text-[11px] uppercase tracking-[0.2em] text-[#00e5ff] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#00e5ff] hover:text-slate-950 sm:block"
          >
            {t.cta}
          </a>
        </div>
      </div>
    </motion.header>
  );
};
